import superagent from 'superagent';
import config from '../config/config';
import store from '../store';
import vuetify from '../plugins/vuetify';

class ApiUtil {
  constructor() {
    this.token = null;
    this.url = config.API_URL;
    // Register superagent middleware. This function will trigger on each request.
    this.api = superagent.agent().use((request) => {
      if (this.token) {
        request.set('token', this.token);
      }
    });
  }

  setToken(token) {
    this.token = token;
  }

  async login(username, password) {
    const data = { username, password };
    const result = await this.api.post(`${this.url}/user/login`).send(data);
    return result.body.data;
  }

  async logout() {
    const data = { token: this.token };
    const result = await this.api.post(`${this.url}/user/logout`).send(data);
    return result.body.data;
  }

  async getAllMachines() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/machine`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteMachineById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/machine`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.machine')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveMachine(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/machine`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.machine')), mode: 'success' });
    }
    return result;
  }

  async getAllMicrocontroller() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/microcontroller`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteMicrocontrollerById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/microcontroller`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.dataController')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveMicrocontroller(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/microcontroller`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.dataController')), mode: 'success' });
    }
    return result;
  }

  async getAllWeavingMachine() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/weaving-machine`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteWeavingMachineById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/weaving-machine`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.weavingMachine')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveWeavingMachine(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/weaving-machine`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.weavingMachine')), mode: 'success' });
    }
    return result;
  }

  async getAllUser() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/user`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteUserById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/user`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.user')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveUser(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/user`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.user')), mode: 'success' });
    }
    return result;
  }

  async getAllGroup() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/group`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteGroupById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/group`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.group')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveGroup(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/group`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.group')), mode: 'success' });
    }
    return result;
  }

  async getAllPermission() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/permission`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllGraphStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/graph/all`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getDailyGraphStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/graph/daily`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getWeeklyGraphStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/graph/weekly`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getMonthlyGraphStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/graph/monthly`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getYearlyGraphStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/graph/yearly`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getLatest100GraphStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/graph/latest-100`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllSumStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/sum/all`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getDailySumStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/sum/daily`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getWeeklySumStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/sum/weekly`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getMonthlySumStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/sum/monthly`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getYearlySumStat() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/sum/yearly`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getStatOverview() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/stat/overview`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllAnnotations() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/annotation`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async deleteAnnotationById(data) {
    let result = null;
    try {
      const response = await this.api.del(`${this.url}/annotation`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      } else {
        store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.deletedSuccessfully', vuetify.framework.lang.t('$vuetify.annotation')), mode: 'success' });
      }
      return result;
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async saveAnnotation(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/annotation`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.annotation')), mode: 'success' });
    }
    return result;
  }

  async saveAnnotationForm(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/annotation/form`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.annotation')), mode: 'success' });
    }
    return result;
  }

  async getAllAnnotationForms() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/annotation/form`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async getAllPreferences() {
    let result = null;
    try {
      const response = await this.api.get(`${this.url}/user/preferences`);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    }
    return result;
  }

  async savePreferences(data) {
    let result = null;
    try {
      const response = await this.api.post(`${this.url}/user/preferences`).send(data);
      result = response.body;
    } catch (err) {
      result = { success: false, message: `${err.response.status}: ${err.message}` };
    }

    if (typeof result === 'boolean') {
      if (!result) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
        return result;
      }
    }

    if ('success' in result) {
      if (!result.success) {
        store.dispatch('setSnackbar', { text: result.message ? result.message : vuetify.framework.lang.t('$vuetify.generalErrorMessage'), mode: 'error' });
      }
    } else {
      store.dispatch('setSnackbar', { text: vuetify.framework.lang.t('$vuetify.savedSuccessfully', vuetify.framework.lang.t('$vuetify.preferences')), mode: 'success' });
    }
    return result;
  }
}

export default new ApiUtil();
